import { call, put, delay } from 'redux-saga/effects';
import { axiosApiInstance } from './_httpHeaders';
import { reactAlert } from 'common/CommonFunction';
import { startLoading, finishLoading, initLoading } from 'src/modules/loadingState';

const createRequestSaga = (type, request) => {
  // 성공 및 실패 액션 타입을 정의
  const SUCCESS = `${type}_SUCCESS`;
  const FAILURE = `${type}_FAILURE`;

  // 파라미터로 action을 받아 오면 액션의 정보를 조회할 수 있다.
  return function* (action) {
    // 로딩 시작
    yield put(startLoading(type));
    try {
      // call을 사용하면 Promise를 반환하는 함수를 호출하고, 기다릴 수 있다.
      // 첫 번째 파라미터는 함수, 나머지 파라미터는 해당 함수에 넣을 인수
      const response = yield call(request, action.payload);

      const errMsg = {
        400: '관리자에게 문의 해주세요',
        900: '잠시 후 다시 시도해 주세요. \n문제가 지속 될 경우, 관리자에게 문의 해주세요.',
        503: '잠시 후 다시 시도해 주세요. \n문제가 지속 될 경우, 관리자에게 문의 해주세요.',
        408: '중복로그인 되었습니다.',
        409: '중복로그인 되었습니다.',
      };
      const errDupLogin = ['408', '409'];
      if (Object.keys(errMsg).includes(response.data.code)) {
        reactAlert({ message: errMsg[response.data.code] }, () => {
          if (errDupLogin.includes(response.data.code)) {
            window.sessionStorage.clear();
            window.location.replace(`/intro`);
          }
        });
      }

      // 응답 성공
      yield put({
        type: SUCCESS,
        payload: response.data,
        headers: response.headers,
      });
    } catch (e) {
      const errors = [401, 404];
      const errMsg = '잘못된 경로입니다.\n 서비스 초기 페이지로 이동합니다.';

      if (errors.includes(e.response.status)) {
        // 로딩 state 초기화
        yield put(initLoading());
        const token = sessionStorage.getItem('TOKEN');
        if (token && token.length > 0) {
          // 토큰이 있는 경우, 로그아웃 => 세션비우기
          //yield put(setLogout(usId)); 작동X
          yield call(
            reactAlert({ message: errMsg }, () => {
              try {
                axiosApiInstance({
                  method: 'put',
                  url: `${process.env.REACT_APP_API_URL}/user/intro/setLogout.do`,
                  data: {
                    usId: sessionStorage.getItem('USER_ID'),
                  },
                });
                setTimeout(() => {
                  window.sessionStorage.clear();
                  window.location.replace(`/intro`);
                }, [500]);
              } catch {}
            }),
            null
          );
        }
        // 토큰 없으면 바로 세션비우기
        reactAlert({ message: errMsg }, () => {
          window.sessionStorage.clear();
          window.location.replace(`/intro`);
        });
      }
      if (e.response.status === 900) {
        yield put(initLoading());
        reactAlert({
          message: '잠시 후 다시 시도해 주세요. \n문제가 지속 될 경우, 관리자에게 문의 해주세요.',
        });
      }
      if (e.response.status === 503) {
        yield put(initLoading());
        reactAlert({
          message: '잠시 후 다시 시도해 주세요. \n문제가 지속 될 경우, 관리자에게 문의 해주세요.',
        });
      }
      yield put({
        type: FAILURE,
        payload: e,
        error: true,
      });
    }
    // 로딩 끝
    yield put(finishLoading(type));
  };
};

export default createRequestSaga;

// 토큰  401
